import { BadgeVariants } from '@carboledger/ui';
import { DECLARATION_STATUS_TONE } from '@/config/statusTones';

// The discrepancy modal's field sections; its card fills the grid column-first.
export const buildDeclarationDiscrepancySections = (t, declaration) => {
  if (!declaration) return [];
  const unit = declaration.byUnit?.[declaration.unitType] ?? {};
  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: declaration.materialName },
        { label: t('FIELD_SENT_BY'), value: declaration.supplierName },
        { label: t('FIELD_RECEIVED_AT'), value: declaration.facilityName },
        { label: t('FIELD_DATE_OF_DISPATCH'), value: declaration.dateOfDispatch },
        { label: t('DECLARATIONS_COL_DATE_OF_ISSUANCE'), value: declaration.dateOfIssuance },
        {
          label: t('FIELD_STATUS'),
          value: declaration.status,
          type: 'status',
          tone: DECLARATION_STATUS_TONE[declaration.statusCode] ?? BadgeVariants.default,
        },
        { label: t('FIELD_TERMINAL'), value: declaration.terminal },
        { label: t('FIELD_DATE_OF_DISCHARGE'), value: declaration.dateOfDischarge },
        {
          label: t('FIELD_TOTAL_SHIPMENT_LINKED'),
          value: String(declaration.linkedShipmentCount ?? 0),
        },
      ],
    },
    {
      title: t('SECTION_QUANTITY_IN_UNIT', { unit: unit.unit }),
      fields: [
        { label: t('FIELD_RECEIVED_DECLARATION_QUANTITY'), value: unit.receivedQty },
        { label: t('DECLARATIONS_COL_ADJUSTED_QTY'), value: unit.adjustedQty },
      ],
    },
  ];
};
